import React from "react";
import { Link } from "react-router-dom";
import { motion } from "motion/react";
import Layout from "../components/layout/Layout";
import { ArrowLeft, Mail, MapPin, Clock, Send, MessageCircle } from "lucide-react";

export default function ContactPage() {
  return (
    <Layout>
      <div id="contact_page" className="min-h-screen bg-neutral-950">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-20">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <Link
              to="/"
              className="inline-flex items-center gap-2 text-neutral-400 hover:text-white mb-8 transition-colors"
            >
              <ArrowLeft className="w-5 h-5" />
              <span className="text-lg font-extralight">На главную</span>
            </Link>

            <div className="flex items-center gap-4 mb-10">
              <div className="w-12 h-12 rounded-md bg-primary-500/10 flex items-center justify-center">
                <Mail className="w-6 h-6 text-primary-400" />
              </div>
              <div>
                <h1 className="text-3xl lg:text-4xl font-medium text-white">
                  Контакты
                </h1>
                <p className="text-lg font-extralight text-neutral-500 mt-1">
                  Свяжитесь с нами удобным способом
                </p>
              </div>
            </div>

            <div className="space-y-8">
              <motion.div
                initial={{ opacity: 0, y: 16 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.1 }}
                className="grid grid-cols-1 md:grid-cols-2 gap-6"
              >
                <div className="p-6 rounded-md bg-neutral-900/60 border border-neutral-800/40">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 rounded-md bg-primary-500/10 flex items-center justify-center">
                      <Mail className="w-5 h-5 text-primary-400" />
                    </div>
                    <h3 className="text-xl font-medium text-white">Электронная почта</h3>
                  </div>
                  <p className="text-lg font-extralight text-neutral-400 mb-3">
                    Для общих вопросов, предложений и обращений
                  </p>
                  <a
                    href="mailto:info@obstuchim.ru"
                    className="text-lg font-extralight text-primary-400 hover:text-primary-300 transition-colors"
                  >
                    info@obstuchim.ru
                  </a>
                </div>

                <div className="p-6 rounded-md bg-neutral-900/60 border border-neutral-800/40">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 rounded-md bg-primary-500/10 flex items-center justify-center">
                      <Send className="w-5 h-5 text-primary-400" />
                    </div>
                    <h3 className="text-xl font-medium text-white">Telegram</h3>
                  </div>
                  <p className="text-lg font-extralight text-neutral-400 mb-3">
                    Быстрая связь и поддержка пользователей
                  </p>
                  <a
                    href="https://t.me/obstuchim"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-lg font-extralight text-primary-400 hover:text-primary-300 transition-colors"
                  >
                    @obstuchim
                  </a>
                </div>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 16 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.2 }}
                className="grid grid-cols-1 md:grid-cols-2 gap-6"
              >
                <div className="p-6 rounded-md bg-neutral-900/60 border border-neutral-800/40">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 rounded-md bg-primary-500/10 flex items-center justify-center">
                      <MapPin className="w-5 h-5 text-primary-400" />
                    </div>
                    <h3 className="text-xl font-medium text-white">Местоположение</h3>
                  </div>
                  <p className="text-lg font-extralight text-neutral-400">
                    Россия, Москва
                  </p>
                  <p className="text-lg font-extralight text-neutral-500 mt-1">
                    Платформа работает полностью онлайн
                  </p>
                </div>

                <div className="p-6 rounded-md bg-neutral-900/60 border border-neutral-800/40">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 rounded-md bg-primary-500/10 flex items-center justify-center">
                      <Clock className="w-5 h-5 text-primary-400" />
                    </div>
                    <h3 className="text-xl font-medium text-white">Время работы</h3>
                  </div>
                  <p className="text-lg font-extralight text-neutral-400">
                    Пн — Пт: 10:00 — 19:00 (МСК)
                  </p>
                  <p className="text-lg font-extralight text-neutral-500 mt-1">
                    Ответ на обращения — в течение 24 часов
                  </p>
                </div>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 16 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.3 }}
                className="p-6 rounded-md bg-neutral-900/60 border border-neutral-800/40"
              >
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 rounded-md bg-primary-500/10 flex items-center justify-center">
                    <MessageCircle className="w-5 h-5 text-primary-400" />
                  </div>
                  <h3 className="text-xl font-medium text-white">Обратная связь</h3>
                </div>
                <p className="text-lg font-extralight text-neutral-400 mb-4">
                  Мы ценим ваше мнение и стремимся сделать платформу лучше.
                  Если у вас есть предложения по улучшению сервиса, сообщения
                  об ошибках или любые другие вопросы — напишите нам любым
                  удобным способом, и мы обязательно ответим.
                </p>
                <div className="flex flex-wrap gap-4">
                  <a
                    href="mailto:info@obstuchim.ru"
                    className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-600 hover:bg-primary-500 text-white text-lg font-extralight transition-colors"
                  >
                    <Mail className="w-5 h-5" />
                    Написать на почту
                  </a>
                  <a
                    href="https://t.me/obstuchim"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-neutral-800 hover:bg-neutral-700 text-white text-lg font-extralight transition-colors"
                  >
                    <Send className="w-5 h-5" />
                    Написать в Telegram
                  </a>
                </div>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 16 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.4 }}
                className="p-6 rounded-md bg-neutral-900/40 border border-neutral-800/30"
              >
                <h3 className="text-xl font-medium text-white mb-3">
                  Юридическая информация
                </h3>
                <p className="text-lg font-extralight text-neutral-400 mb-2">
                  Платформа "Обстучим" оказывает информационные услуги
                  в соответствии с действующим законодательством Российской Федерации.
                </p>
                <p className="text-lg font-extralight text-neutral-500">
                  Подробнее об условиях использования —{" "}
                  <Link
                    to="/terms"
                    className="text-primary-400 hover:text-primary-300 transition-colors"
                  >
                    Пользовательское соглашение
                  </Link>{" "}
                  и{" "}
                  <Link
                    to="/privacy"
                    className="text-primary-400 hover:text-primary-300 transition-colors"
                  >
                    Политика конфиденциальности
                  </Link>.
                </p>
              </motion.div>
            </div>
          </motion.div>
        </div>
      </div>
    </Layout>
  );
}
